import { render, staticRenderFns } from "./_folder.vue?vue&type=template&id=6b408a44&scoped=true"
import script from "./_folder.vue?vue&type=script&lang=ts"
export * from "./_folder.vue?vue&type=script&lang=ts"
import style0 from "./_folder.vue?vue&type=style&index=0&id=6b408a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b408a44",
  null
  
)

export default component.exports